import { Opening, Services, Scale } from './scenes01to03';
import { People, Video, ScaleOfVideo } from './scenes04to06';
import { AILearning, Question, BadSocial, Reveal } from './scenes07to10';
import { Journey, Work, AI } from './scenes11to15';
import { Beats, Tours, Script, JacksonStops, Finale } from './scenes16to20';

export const SCENE_COMPONENTS = {
  Opening, Services, Scale, People, Video, ScaleOfVideo, AILearning, Question, BadSocial, Reveal,
  Journey, Work, AI, Beats, Tours, Script, JacksonStops, Finale,
};
